import { isAnyOf } from "@reduxjs/toolkit";

import { defaultContainer } from "../../consts/collectionPoint";
import {
  deleteInviteToMobileAppThunk,
  getCollectionPointDetailThunk,
  inviteToMobileAppThunk,
  setCollectionPointContainers,
  setCollectionPointDetailPagination,
} from "../../reducers/collectionPointReducer";
import { getCollectionYardsVisitsDetailThunk } from "../../reducers/collectionYardsVisitsDetailReducer";
import { getSkeletonMockedArray } from "../../utils/tables/getSkeletonMockedArray";
import { startAppListening } from "./listenerMiddleware";

export const collectionPointDetailListener = (): void => {
  startAppListening({
    matcher: isAnyOf(getCollectionPointDetailThunk.pending),
    effect: async (dispatchProps, { getState, dispatch }) => {
      const state = getState();
      const collectionPoint = state.collectionPoint.collectionPoint;
      const page = state.collectionPoint.pagination.page;
      const collectionPoints = state.collectionPoints.locations;
      const collectionPointLocation = collectionPoints.find(
        (location) => location.locationId === collectionPoint.locationId
      );

      const containers = collectionPoint.containers;
      const locationId = dispatchProps.meta.arg;

      dispatch(getCollectionYardsVisitsDetailThunk(locationId));

      if (collectionPointLocation && page === 1) {
        const mockedContainers = getSkeletonMockedArray(
          defaultContainer,
          collectionPointLocation.containerCount,
          containers.length
        );
        dispatch(setCollectionPointContainers(mockedContainers));
      }

      if (page > 1) {
        const mockedContainers = getSkeletonMockedArray(defaultContainer, 3, containers.length);
        const newContainers = [...containers, ...mockedContainers];
        dispatch(setCollectionPointContainers(newContainers));
      }
    },
  });

  startAppListening({
    matcher: isAnyOf(deleteInviteToMobileAppThunk.fulfilled, inviteToMobileAppThunk.fulfilled),
    effect: async (_, { dispatch, getState }) => {
      const state = getState();
      const collectionPointId = state.collectionPoint.collectionPoint.locationId;

      dispatch(getCollectionPointDetailThunk(collectionPointId));
    },
  });

  startAppListening({
    actionCreator: setCollectionPointDetailPagination,
    effect: async (_, { dispatch, getState }) => {
      const state = getState();
      const collectionPointId = state.collectionPoint.collectionPoint.locationId;

      dispatch(getCollectionPointDetailThunk(collectionPointId));
    },
  });
};
